export default __webpack_public_path__ + "ca2e97cea14a786bb7648c4d62e7a3c2.svg";